import { render } from "./scoreResult.vue?vue&type=template&id=9a2163f2&scoped=true"
import script from "./scoreResult.vue?vue&type=script&lang=js"
export * from "./scoreResult.vue?vue&type=script&lang=js"

import "./scoreResult.vue?vue&type=style&index=0&id=9a2163f2&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a2163f2"]])

export default __exports__